import React from 'react';
import { Switch } from 'react-router-dom';
import { PATH } from 'shared/constants';
import { AuthRoute, PublicRoute } from 'layouts';
import { Login, OTP, Dashboard } from 'pages';

const Routes: React.FC = () => (
  <Switch>
    {/* <Route
      path="/"
      exact
      component={() => <></>}
    /> */}
    <PublicRoute
      path="/"
      exact
      component={Login}
    />
    <PublicRoute
      path={PATH.OTP}
      component={(props) => <OTP {...props} />}
    />
    <AuthRoute
      path={PATH.DASHBOARD}
      component={Dashboard}
    />
  </Switch>
);
export default Routes;
